import React, { useEffect, useRef, useState } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap';
import logoCenec from '../assets/cenec_2.svg';
import logoChorotega from '../assets/chorotega_2.svg';
import { useFormContext } from 'react-hook-form';

export const SlideFive = ({ formData, setFormData }) => {
    const { setValue, formState: { errors } } = useFormContext();

    const handleFileChange = (event, fieldName) => {
        const file = event.target.files[0];
        if (file) {
            // Actualiza el formData con el archivo seleccionado en el campo correspondiente
            setFormData(prevData => ({ ...prevData, [fieldName]: file }));

            // Si deseas que el campo esté en react-hook-form para validación
            setValue(fieldName, file, { shouldValidate: true });
        }
    };

    return (
    <Container className='' style={{ maxWidth: '1200px' }}>
        <div className='d-flex justify-content-center mb-3 ms-2 me-2'>
            <Card className='card-custom-style'>
                <Card.Header className='white-bg-color'>
                    <Row className='justify-content-center'>
                        <Col md={10}>
                            <Row className='justify-content-center cenec-bg-color-v2 mx-1 p-3 rounded-1 mb-3 mt-3'>
                                <Col xl={5} md={5} sm={5} xs={12} className='order-last order-sm-first order-md-first' >
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <img src={logoCenec} alt="Logo CENEC" className='img-cenec'/>
                                    </div>
                                </Col>
                                <Col xl={2} md={2} sm={2} className='d-none d-sm-block text-center'>
                                    <div className='vl'></div>
                                </Col>
                                <Col xs={12} className='d-block d-sm-none'>
                                    <div className='hl'></div>
                                </Col>
                                <Col xl={5} md={5} sm={5} xs={12} className='order-first order-sm-last order-md-last' >
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <img src={logoChorotega} alt="Logo Cooperativa Chorotega" className='img-owner' />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Form >
                        <Row className='justify-content-center'>
                            <Col md="10" className='mt-3 mb-5'>
                                <h2 className='fs-5 text-center fw-bold'>CONTRATO CON EL AFILIADO</h2>
                            </Col>
                            <div className="w-100"></div>

                            <Col md="4" sm="12" xs="12" className="mb-3">
                                <Form.Label>Subir parte delantera identidad</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept="image/*"
                                    name='upload_identity_front'
                                    // {...register("upload_identity_front", { required: "La parte delantera de la identidad es requerida" })}
                                    onChange={(e) => handleFileChange(e, "upload_identity_front")}
                                />
                                {errors.upload_identity_front && (
                                    <p className="text-danger">
                                        {errors.upload_identity_front.message}
                                    </p>
                                )}

                            </Col>

                            <Col md="4" sm="12" xs="12" className="mb-3">
                                <Form.Label>Subir parte trasera identidad</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept="image/*"
                                    name='upload_identity_back'
                                    // {...register("upload_identity_back", { required: "La parte trasera de la identidad es requerida" })}
                                    onChange={(e) => handleFileChange(e, "upload_identity_back")}
                                />
                                {errors.upload_identity_back && (
                                    <p className="text-danger">
                                        {errors.upload_identity_back.message}
                                    </p>
                                )}
                            </Col>

                            <Col md="4" sm="12" xs="12" className="mb-3">
                                <Form.Label>Subir RTN</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept="image/*"
                                    name='upload_rtn'
                                    // {...register("upload_rtn", { required: "El RTN es requerido" })}
                                    onChange={(e) => handleFileChange(e, "upload_rtn")}
                                />
                                {errors.upload_rtn && (
                                    <p className="text-danger">
                                        {errors.upload_rtn.message}
                                    </p>
                                )}
                            </Col>

                            <Col md="6" sm="12" xs="12" className="mb-3">
                                <Form.Label>Subir permiso de operación</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept="pdf/*"
                                    name='upload_operation_permit'
                                    // {...register("upload_operation_permit", { required: "El permiso de operación es requerido" })}
                                    onChange={(e) => handleFileChange(e, "upload_operation_permit")}
                                />
                                {errors.upload_operation_permit && (
                                    <p className="text-danger">
                                        {errors.upload_operation_permit.message}
                                    </p>
                                )}
                            </Col>

                            <Col md="6" sm="12" xs="12" className="mb-3">
                                <Form.Label>Subir escritura o carta de constitución</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept="pdf/*"
                                    name='upload_constitution_letter'
                                    // {...register("upload_constitution_letter", { required: "La escritura o carta de constitución es requerida" })}
                                    onChange={(e) => handleFileChange(e, "upload_constitution_letter")}
                                />
                                {errors.upload_constitution_letter && (
                                    <p className="text-danger">
                                        {errors.upload_constitution_letter.message}
                                    </p>
                                )}
                            </Col>

                        </Row>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    </Container>
    )
};